<template>
  <v-col cols="12">
    <div class="mb-4 questionText d-flex align-start">
      <v-chip
        v-if="validated && invalid"
        color="red darken-2 white--text"
        class="text-capitalize mr-3 flex-shrink-0"
        >Required
      </v-chip>
      <template v-else>
        <div
          class="mr-3"
          v-if="question.questionNumber && question.questionNumber.length > 0"
        >
          {{ question.questionNumber }}
        </div></template
      >
      <survey-question-text :text="question.text"></survey-question-text>
    </div>

    <div>
      <radio-list-btn
        v-for="(option, index) in question.options"
        :key="index"
        :text="option.text"
        :value="optionSelected(option.value)"
        @click="setKeyPair(option.value)"
        :inError="validated && invalid"
      ></radio-list-btn>
    </div>
  </v-col>
</template>

<style lang="scss">
.questionText {
  font-size: 1.1rem;
}

.radio-button {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  height: auto !important;
  text-align: left;
  justify-content: start;
  white-space: normal;
  display: block;
  text-transform: none !important;
}
</style>

<script>
import Vue from "vue";
import RadioListBtn from "./RadioList.Btn.vue";
import { isEmptyOrSpaces } from "../utilities/dataUtilities";
import {
  getQuestionSetting,
  questionSettings,
  showQuestion,
  requireQuestion,
  getQuestionHTML,
  getQuestionTextParts,
  questionTextPartType
} from "../constants/Survey";
import SurveyQuestionText from "./Survey.Question.Text.vue";

export default {
  components: {
    RadioListBtn,
    SurveyQuestionText
  },
  data: () => ({
    innerValue: [],
    validated: false
  }),
  props: {
    value: {
      type: Array,
      default: () => []
    },
    question: {
      type: Object
    }
  },
  computed: {
    required() {
      return (
        getQuestionSetting(
          this.question.settings,
          questionSettings.required.key
        ).value == "true" || requireQuestion(this.question, this.innerValue)
      );
    },
    fieldValue() {
      let target = this.innerValue.find(y => y.key === this.question.key);
      return target ? target.value : null;
    },
    valid() {
      return (
        !this.required || (this.required && !isEmptyOrSpaces(this.fieldValue))
      );
    },
    invalid() {
      return !this.valid;
    },
    errors() {
      let errors = [];

      if (this.required && isEmptyOrSpaces(this.fieldValue))
        errors.push({ key: this.question.key, value: "Required" });

      return errors;
    },
    visible() {
      return showQuestion(this.question, this.innerValue);
    },
    questionHTML() {
      return getQuestionHTML(this.question.text);
    },
    questionTextParts() {
      return getQuestionTextParts(this.question.text);
    },
    questionTextPartType() {
      return questionTextPartType;
    }
  },
  watch: {
    value(val) {
      if (!keyPairArraysAreEqual(val, this.innerValue)) {
        this.innerValue = val;
      }
    },
    innerValue(value, prev) {
      if (!keyPairArraysAreEqual(value, prev)) {
        this.$emit("input", this.innerValue);
      }
    }
  },
  methods: {
    setKeyPair(value) {
      let keyPair = { key: this.question.key, value };

      let index = this.innerValue.findIndex(x => x.key === this.question.key);
      if (index > -1) Vue.set(this.innerValue, index, keyPair);
      else this.innerValue.push(keyPair);
    },
    optionSelected(value) {
      let answer = this.innerValue.find(x => x.key === this.question.key);
      return answer ? answer.value === value : false;
    },
    validate() {
      this.validated = true;
      return this.valid;
    },
    reset() {
      this.validated = false;
    }
  },
  mounted() {
    if (this.value) this.innerValue = this.value;
  },
  destroyed() {
    // Clear answer if hidden.
    if (!showQuestion(this.question, this.innerValue)) this.setKeyPair(null);
  }
};

function keyPairArraysAreEqual(a, b) {
  return flatten(a) === flatten(b);

  function flatten(arr) {
    return JSON.parse(JSON.stringify(arr));
  }
}
</script>
